export const agreeToDisagree = [
  { value: '5', text: 'Strongly Agree' },
  { value: '4', text: 'Agree' },
  { value: '3', text: 'Neither agree nor disagree' },
  { value: '2', text: 'Disagree' },
  { value: '1', text: 'Strongly Disagree' },
];
